import ApiComplexes from '@/api/apiComplexes'
import Vue from 'vue'
import router from '../router'
import Complex from '@/models/complex'

const state = {
  complexes: [],
  complex: new Complex()
}

const actions = {
  loadComplexes(context){
    ApiComplexes.all((complexes) => {
      context.commit("updateComplexes", complexes)
    })
  },
  loadComplex({commit, state},complexId){
    console.log("loadComplex",complexId)
    commit("updateComplex", new Complex())
    if (complexId){
      console.log("loadComplex2",complexId)
      ApiComplexes.find(complexId,(complex) =>{
        commit("updateComplex", complex)
      })
    }

  },
  createComplex(context,complex){
    ApiComplexes.create(complex,(response) => {
      router.go(-1)
    })
  },
  updateComplex({commit, state},complex){
    ApiComplexes.update(complex,(response)=>{
      router.go(-1)
    })
  },
  removeComplex(context,complex){
    ApiComplexes.delete(complex,(response)=>{
      context.dispatch('loadComplexes')
    })
  },
  changeStatusToAComplex(context,complex){
    ApiComplexes.changeStatus(complex,(response)=>{
      context.dispatch('loadComplexes')
    })
  }
}

const mutations = {
  updateComplexes(state,complexes){
    state.complex = new Complex()
    state.complexes = complexes
  },
  updateComplex(state,complex){
    state.complex = complex
  }

}

const getters = {
  currentComplexes(state){
    return state.complexes
  },
  currentComplex(state){
    return state.complex
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/complexes.js